import { render } from "./DeviceInfo.vue?vue&type=template&id=dffd7ac0&scoped=true&ts=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=ts"
export * from "./DeviceInfo.vue?vue&type=script&lang=ts"

import "./DeviceInfo.vue?vue&type=style&index=0&id=dffd7ac0&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dffd7ac0"]])

export default __exports__